import React, { useEffect } from "react";
import { useDispatch, useSelector } from "../../../store";
import MobileTableStack from "../../base/MobileTableStack";
import { fetchAlerts } from "../../../slices/alert";
import { Chip } from "@mui/material";
import { TileTypes } from "../../../types/tileType";

interface Props {
  handleView?: (id: number) => void;
  handleEdit?: (id: number) => void;
  handleDisable?: (id: number) => void;
}

const ActiveAlertsStack: React.FC<Props> = (props) => {
  const { handleEdit, handleDisable, handleView } = props;

  const dispatch = useDispatch();
  const { activeAlerts } = useSelector((store) => store.alert);

  useEffect(() => {
    dispatch(fetchAlerts());
  }, [dispatch]);

  const dataRows =
    activeAlerts &&
    activeAlerts?.map((alert) => {
      let rowObject = {
        id: alert.tileId,
        name: `${alert.tileName}`,
        tileType: `${alert.tileType}`,
        alertType: alert.alertType.value,
        alertDelivery: alert.alertDeliveries?.map((r) => (
          <Chip
            key={r.id}
            label={r.value}
            size="small"
            sx={{ m: 0.25 }}
            color="info"
          />
        )),
        datasets: `⚠️ ${alert.alertData}`,
      };

      return rowObject;
    });

  const headers = [
    "name",
    "tileType",
    "alertType",
    "alertDelivery",
    "datasets",
  ];

  return dataRows?.length ? (
    <MobileTableStack
      rows={dataRows!}
      headers={headers}
      handleEdit={handleEdit ? handleEdit : undefined}
      handleDelete={handleDisable ? handleDisable : undefined}
      handleView={handleView ? handleView : undefined}
    />
  ) : (
    <></>
  );
};

export default ActiveAlertsStack;
